// import React from 'react'

// const VendorScoreCard = () => {
//   return (
//     <>
//         <h4>Vendor Score Card</h4>
//     </>
//   )
// }

// export default VendorScoreCard
import { Hidden } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import PieScoreUpdated from '../Custom/ScoreCardComponent/PieScoreUpdated'
import Filter from '../Custom/ScoreCard/Filter'
import TopBoard from '../Custom/ScoreCard/TopBoard'
import DemoChart from '../Custom/ScoreCard/DemoChart'
import StackedBarChart from '../Custom/ScoreCard/StackedColumnChart'
import { useDispatch, useSelector } from 'react-redux'
import { VendorScoreCardReducerAction } from '../../../store/actions/createTicketManageFields'
import { VendorScoreCardApi, VendorScoreCardDashboard } from '../../../common/config'
import ChartGroup from '../Custom/ScoreCard/ChartGroup'
import ChartBasedFilter from '../Custom/ScoreCard/ChartBasedFilter'
import { common } from '../../../services/AdminService'
import MultiSelect from '../../components/multiSelect/MultiSelect'

const VendorScoreCard = () => {
  const [firstStepChart, setFirstStepChart] = useState(false)
  const [divBox, setDivBox] = useState("")
  const [download, setDownload] = useState(null)
  const [filtering, setfiltering] = useState("")
  let vendorScoreGraphList = useSelector((state) =>  state?.vendorScoreCard?.funVendorScoreCard
)
  const [CBF, setCBF] = useState({
    "impact":"All",
    "ttStatus":"All",
    "serviceAffecting":"Both"
  })
  

  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(VendorScoreCardReducerAction(VendorScoreCardDashboard))
  },[])

  useEffect(()=> {
    setDownload(null)
  } , [divBox])

  // console.log(setCBF , setCBF , vendorScoreGraphList , 'asfasdfasdfasdf')

  const downloadPdf = async () => {
    if (!download || download.length === 0) {
        alert("Please select an option to download.");
        return;
    }

    for (let i = 0; i < download.length; i++) {
        const item = download[i];
        if (item?.value && item?.label) {
            try {
                await downloadFile(item);
            } catch (error) {
                console.error(`Error downloading ${item.label}:`, error);
            }
        } else {
            console.error(`Invalid download item: ${item}`);
        }
    }
};

// Helper function to download a single file
const downloadFile = async (item) => {
    const response = await fetch(item.value);
    
    if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.setAttribute('download', `${item.label}.pdf`); // Set the name of the PDF file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the link element after the download

    // Release the object URL after download to free memory
    URL.revokeObjectURL(url);

    // Add a slight delay between downloads if needed
    await new Promise(resolve => setTimeout(resolve, 500));
};




  // console.log(vendorScoreGraphList,"vendorScoreGraphList")
  return (
    <><div style={{ backgroundColor: "#343e59" }}>
      {/* <div>
      <br/>
      <br/>
      <br/>
        <div class="container-fluid mt-2 ">
          <div class="row">
            <div class="col-2  scorecard-bar" style={{ backgroundImage: "linear-gradient( 135deg, #ABDCFF 10%, #0396FF 100%)" }}>
              Trouble Ticket - 100
            </div>
            <div class="col-2 scorecard-bar" style={{ backgroundImage: "linear-gradient( 135deg, #2AFADF 10%, #4C83FF 100%)" }}>
              Punctuality - 100
            </div>
            <div class="col-2 scorecard-bar" style={{ backgroundImage: "linear-gradient( 135deg, #FFD3A5 10%, #FD6585 100%)" }}>
              Site Spilover - 100
            </div>
            <div class="col-2 scorecard-bar" style={{ backgroundImage: "linear-gradient( 135deg, #EE9AE5 10%, #5961F9 100%)" }}>
              Performance - 100
            </div>
            <div class="col-2 scorecard-bar" style={{ backgroundImage: "linear-gradient( 135deg, #FFD3A5 10%, #5961F9 100%)" }}>
              Site Downtime - 100
            </div>
          </div>
        </div>
      </div> */}

      <Filter filtering={filtering} setDivBox={setDivBox} setfiltering={setfiltering} />
      
      <br/>
      <br/>
      <TopBoard filtering={filtering} setDivBox={setDivBox} firstStepChart={firstStepChart} setFirstStepChart={setFirstStepChart} />
        
        {/* {
          divBox && <div  style={
            {
              width : "1000px",
              display : "flex"
            }
          }>
            <MultiSelect option={vendorScoreGraphList?.map((item) => {
              return {
                label : item?.toollabeling,
                value : item?.graphUrl
              }
            })} cb={(data) => setDownload(data)} defaultValue={download} label="Download PDF"  />
          <button
            onClick={() => downloadPdf()}
            className="btn btn-primary btn-lg"
            style={{
              marginTop: "38px",
              marginLeft: "10px",
              padding: "6px 14px",
              fontSize: "16px",
              display: "inline-block",
            }}
          >
            Download PDF
          </button>

          </div>
        } */}

      <ChartBasedFilter CBF={CBF} setCBF={setCBF} divBox={divBox} />

        {/* <div> MultiSelect Input here</div> */}


      {
        divBox!="" ? <div class="row">


        <ChartGroup filtering={filtering}/>

        
          {/* <div class="h-100"></div>
          <div class="col text-center "><StackedBarChart chartType={"bar"} minBarWidth={80} numDataPoints={2} data={{series:[],label:[]}} /></div>
          <div class="w-100"></div>
          <div class="col text-center "><StackedBarChart chartType={"bar"} minBarWidth={80} numDataPoints={2} data={{series:[],label:[]}} /></div>
          <div class="h-100"></div>
          <div class="col text-center "><StackedBarChart chartType={"bar"} minBarWidth={80} numDataPoints={2} data={{series:[],label:[]}} /></div> */}
        </div> : <></>
      }

      <br/>
      <br/>
      <br/>
    </div>
    </>
  )
}

export default VendorScoreCard
